import { Box, Button, Collapse, Group, ScrollArea, Stack, Text, Title } from '@mantine/core'
import React from 'react';
import faqs from '../data/faq-data';
import AccordionList from '../components/AccordionList';

const FAQ = () => {
  return (
    <>
      <Title align='center' fz={24}>Frequently Asked Questions</Title>
      <AccordionList data={faqs} />
    </>
  )
}

export default FAQ